import { View } from 'dripsy';
import * as React from 'react';
const TEST_ID = 'doppio-pattern-radio-group';
const RadioGroup = React.forwardRef(({ accessibilityHint, accessibilityLabel, children, name, onChange, value }, forwardedRef) => (React.createElement(View, { ref: forwardedRef, accessibilityRole: "radiogroup", accessibilityHint: accessibilityHint, accessibilityLabel: accessibilityLabel, testID: TEST_ID }, React.Children.map(children, (item, index) => {
    const totalChildren = React.Children.count(children);
    const isOnlyChild = totalChildren === 1;
    const isLastChild = totalChildren - 1 === index;
    const verticalSpacing = { paddingBottom: '$2' };
    const shouldAddVerticalSpacing = !isOnlyChild && !isLastChild;
    return (React.createElement(View, { sx: { ...(shouldAddVerticalSpacing && verticalSpacing) } }, React.cloneElement(item, {
        name,
        isChecked: value === item.props.value,
        onChange: (value) => {
            if (onChange)
                onChange(value);
        },
    })));
}))));
const RadioGroupCompound = Object.assign({}, RadioGroup, {
    displayName: 'RadioGroup',
    testID: TEST_ID,
});
export { RadioGroupCompound as RadioGroup };
//# sourceMappingURL=RadioGroup.js.map